<template>
<section class="hero">
    <v-parallax class="paralax-hero" height="80%" dark :src="ForrestTrail" >
        <div class="logo-holder">
            <v-img width="200" :src="LogoWhite" />
        </div>
        <v-row align="center" justify="center" class="align-center">
            <v-col cols="12" class="headline-container text-center">
                <h1 class="display-2 font-weight-bold white--text with-shadow" v-html="$t('headline_1') + '<br>' + $t('headline_2')">
                </h1>
                <v-col cols="12" class="text-center">
                <span class="sum-emissions">
                    <h3 class="display-1 font-weight-bold">
                        {{formattedEmissionsNumber}} CO<sup class="co2">2</sup>e
                    </h3>
                </span>
                </v-col>
            </v-col>
        </v-row>

    </v-parallax>
</section>
</template>

<i18n>
{
  "en": {
      "headline_1": "Climate contribution",
      "headline_2": "in the total amount of",
      "sub_headline": ""
  },
  "de": {
      "headline_1": "Klimabeitrag",
      "headline_2": "in Höhe von insgesamt",
      "sub_headline": ""
  }
}
</i18n>

<script>
import ForrestTrail from '@/assets/forrest_trail.jpg';
import LogoWhite from '@/assets/conClimateLogoWebWhite.svg';

export default {
  name: 'Hero',
  data() {
    return {
      ForrestTrail,
      LogoWhite,
    };
  },
  props: {
    sumEmissions: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  computed: {
    formattedEmissionsNumber() {
      if (this.sumEmissions >= 500) {
        return `${Number(((this.sumEmissions / 1000.00).toFixed(2))).toLocaleString('de-DE')} t`;
      }

      return `${Number(this.sumEmissions.toFixed(2)).toLocaleString('de-DE')} kg`;
    },
  },
};
</script>

<style lang="scss" scoped>
.co2 {
    top: 0.3em !important;
}
.hero {
    position: relative;
    display: flex;
    flex-shrink: 0;
    flex-grow: 1;
    min-width: 100%;
    height: 85vh !important;
    padding: 0px !important;
}

.paralax-hero {
    min-height: 100% !important;
    width: 100%;
}

.logo-holder {
    position: absolute;
    top: 25px;
    left: 25px;
}

.sum-emissions {
    position: relative;
    display: inline-block;
    border-radius: 30px;
    background: white;
    color: black;
    margin: 1rem;
    padding: 0.7rem 4rem 0.7rem 3rem;
}

.with-shadow {
    text-shadow: 2px 2px #333;
}

.lower-emission-container{
    position: relative;
    bottom: 10%;
}
</style>
